module.exports = __webpack_public_path__ + "static/media/frog(29).634e1b1e.PNG";